import { useEffect } from "react";

export default function CookieBanner() {
  useEffect(() => {
    const allowedOrigin = "https://impact-2025.cchub.africa";
    if (window.location.origin !== allowedOrigin) return;

    const existingScript = document.querySelector(
      'script[src*="app.termly.io/resource-blocker"]'
    );
    if (existingScript) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://app.termly.io/resource-blocker/39e2445e-80c0-464b-a1d8-599173330a3a?autoBlock=off";
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return null;
}
